import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { Overline } from "@/components/Btn";
import { Breadcrumb } from "@/components/Breadcrumb";
import { CtaBand } from "@/components/CtaBand";
import { ARTICLES } from "@/data/conseils";

export default function Conseils() {
  const crumbs = [
    { label: "Accueil", to: "/" },
    { label: "Conseils", to: "/conseils/" },
  ];
  return (
    <>
      <Seo
        title="Conseils enseignes & communication visuelle | Ronalp Enseigne"
        description="Guides et conseils sur les enseignes lumineuses : prix, choix des lettres, couleur LED, autorisations. Par Ronalp Enseigne, fabricant et installateur."
        path="/conseils/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-30" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
          <Breadcrumb items={crumbs} />
          <Reveal className="mt-8 max-w-3xl">
            <Overline>Conseils</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white leading-[0.98]">Guides &amp; conseils</h1>
            <p className="mt-5 text-lg text-slate-300">Nos réponses aux questions que vous vous posez avant de lancer votre projet d'enseigne ou de signalétique.</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ARTICLES.map((a) => (
            <StaggerItem key={a.slug}>
              <Link to={`/conseils/${a.slug}/`} className="group flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-ink-800 hover:border-signature/40 transition-all" data-testid={`article-${a.slug}`}>
                <div className="relative h-44 overflow-hidden">
                  <img src={a.image} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-800 to-transparent" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h2 className="text-lg font-semibold text-white group-hover:text-signature transition-colors">{a.title}</h2>
                  <p className="mt-2 text-sm text-slate-400 line-clamp-2 flex-1">{a.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between text-xs font-mono uppercase tracking-wider text-chrome-dark">
                    <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {a.readingTime}</span>
                    <ArrowUpRight className="h-4 w-4 group-hover:text-signature transition-colors" />
                  </div>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <CtaBand />
    </>
  );
}
